import axios from "../helpers/axios";
import { IAutomationField, PageableData } from "../helpers/types";

class AutomationService {

  public getCreatorAutomationSettings = () => {
    const url = `/automation`;
    return new Promise<PageableData<IAutomationField[]>>((resolve, reject) => {
      axios
        .get(url)
        .then((response) => {
          if (response?.data?.data) resolve(response.data.data);
          else reject("Something went wrong");
        })
        .catch((error) => {
          if (error?.response?.data?.message) reject(error.response.data.message);
          else reject("Something went wrong");
        });
    });
  };

  public updateStatus = (fieldName: any) => {
    const url = `/automation/updateStatus`;
    return new Promise<any>((resolve, reject) => {
      axios
        .patch(url, fieldName)
        .then((response) => {
          if (response?.data) resolve(response.data);
          else reject("Something went wrong");
        })
        .catch((error) => {
          if (error?.response?.data?.message) reject(error.response.data.message);
          else reject("Something went wrong");
        });
    });
  };

  public getCreatorAutomationFieldData = (field : any) => {
    const url = `/automation/fieldData?field=${field}`;
    return new Promise<PageableData<IAutomationField>>((resolve, reject) => {
      axios
        .get(url)
        .then((response) => {
          if (response?.data?.data) resolve(response.data.data);
          else reject("Something went wrong");
        })
        .catch((error) => {
          if (error?.response?.data?.message) reject(error.response.data.message);
          else reject("Something went wrong");
        });
    });
  };

  public updateAutomation = (data: FormData, setProgress: Function) => {
    return new Promise<any>((resolve, reject) => {
      axios
        .patch(`/automation/update`, data, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
          onUploadProgress: (event) => {
            let progress = Math.round((100 * event.loaded) / event.total!);
            progress = Math.round(progress / 2);
            if (progress <= 50) {
              setProgress(progress);
            }
          },
        })
        .then((response) => {
          if (response?.data?.data) {
            resolve(response.data.data);
          } else if (response?.data?.message) {
            resolve(response.data);
          } else {
            reject("Something went wrong.");
          }
        })
        .catch((error) => {
          if (error?.response?.data?.message) reject(error.response.data.message);
          else reject("Something went wrong.");
        });
    });
  };

}

export const automationService = new AutomationService();
